import { create } from 'zustand';

interface UserState {
  avatarUrl: string | null;
  setAvatar: (url: string | null) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()((set) => ({
  avatarUrl: null,
  
  setAvatar: (url: string | null) => {
    set({ avatarUrl: url });
  },
  
  clearUser: () => {
    set({ avatarUrl: null });
  },
}));
